module.exports = __webpack_public_path__ + "static/img/94056C_3_4_R_20191203_fit.9dae1c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/94056C_3_4_R_20191203_fit.png
// module id = 88K5
// module chunks = 0